export const MAX_STREAK = 5000;
export const MIN_STREAK = 0;
